import type { EditorState } from '../store/editorState';

const isEnabled = (state: EditorState) => state.schoolMode.enabled;

export { isEnabled };
